<template>
  <div class="w-full flex flex-col 3sm:mt-188 xs:mt-20 px-6">
    <div
      class="champ-type-wrapper relative overflow-hidden w-227 h-12 float-left"
    >
      <span
        class="champ-type absolute inset-0 m-auto w-full text-very-light-gray text-2 uppercase text-center z-10 flex items-center justify-center"
        >CHAMPION</span
      >
      <div class="absolute w-162 h-12 inset-0 m-auto bg-vivid-pink"></div>
    </div>
    <div class="w-full flex flex-row">
      <h1 class="monster-name font-rakkas 3sm:text-8.4xl xs:text-5 text-white">
        Valdrick
      </h1>
    </div>
    <div class="w-full relative">
      <img
        class="champ-img w-full"
        :src="`${imgPath}/Section07/npc-super.png`"
      />
    </div>
    <div
      class="flex flex-col 3sm:-mt-550 xs:-mt-440 z-10 bg-black bg-opacity-30 p-2 shadow-mobile-desc"
    >
      <span
        class="font-mulish-bold text-very-pale-violet md:text-2.2 3sm:text-2 xs:text-1.8"
      >
        A Loner Champion Who's Obsessed with Winning
      </span>
      <p
        class="mt-8 font-mulish-regular text-very-light-gray md:text-1.8 3sm:text-1.6 sm:text-1.2 md:tracking-wider 3sm:tracking-normal 3sm:leading-2.2 xs:leading-tight"
      >
        One of the beings known as Champion in Eastland. He is also called the
        Savage King because there are many tattoos and scars all over his body.
        Unlike other Champions who settle down and live, Valdrick wanders alone
        on the continent.
        <br /><br />
        He was a weak boy who was worried about his parents because he did not
        feel proper emotions from birth, but he learned various emotions from
        "delightedness" through the teaching of his master who recognized him.
        He grew up to be stronger than anyone else by learning physical and
        martial arts he learned from his master, but there was a problem. It was
        the feeling of "delightedness" only in battle.
        <br /><br />
        After becoming obsessed with battle, he left the town because of
        something, and won many battles, becoming a warrior and Champion that no
        one could touch. Rumor has it that he became the oldest and fastest
        Champion among other Champions.
        <br /><br />
        Always looking for strong beings because of filling in the deficient
        emotions, and often the towns he passed by were damaged. However,
        Valdrick doesn't seem to care. He also had a place to stay for a while
        called Phobos.
        <br /><br />
        No one knows the purpose for his visits, but.... There is widespread
        anxiety in Mars that something is about to happen.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.champ-type-wrapper:before {
  content: '';
  position: absolute;
  top: -15px;
  left: 0px;
  border-top: 30px solid transparent;
  border-right: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
.champ-type-wrapper:after {
  content: '';
  position: absolute;
  top: -15px;
  right: 0px;
  border-top: 30px solid transparent;
  border-left: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
</style>
